import {ThuisverzorgerDienst, ThuisverzorgerDienstDto} from './thuisverzorger-dienst';

export class Thuisverzorger {

  static deserialize(dto: ThuisverzorgerDto): Thuisverzorger {
    return new Thuisverzorger(
      dto.id,
      dto.voornaam,
      dto.achternaam,
      dto.personeelsnummer,
      dto.email,
      dto.diensten.map(dienstDto => ThuisverzorgerDienst.deserialize(dienstDto)),
    );
  }

  static verwijderd(id: string, personeelsnummer: string): Thuisverzorger {
    return new Thuisverzorger(
      id,
      'Verwijderde thuisverzorger',
      '',
      personeelsnummer,
      null,
      null,
      true,
    );
  }

  constructor(
    private id: string,
    private voornaam: string,
    private achternaam: string,
    private personeelsnummer: string,
    private email: string,
    private diensten: Array<ThuisverzorgerDienst>,
    private verwijderd: boolean = false,
  ) {
  }

  getId(): string {
    return this.id;
  }

  hasId(id: string): boolean {
    return this.id === id;
  }

  getVoornaam(): string {
    return this.voornaam;
  }

  getAchternaam(): string {
    return this.achternaam;
  }

  getNaam(): string {
    return `${this.getAchternaam()} ${this.getVoornaam()}`;
  }

  getPersoneelsnummer(): string {
    return this.personeelsnummer;
  }

  getEmail(): string {
    return this.email;
  }

  hasDienstId(dienstId: string): boolean {
    return this.diensten.some(dienst => dienst.getId() === dienstId);
  }

  getDiensten(): Array<ThuisverzorgerDienst> {
    return this.diensten;
  }

  getUniqueZoneIds(): Array<string> {
    const allZoneIds = this.diensten.flatMap(thuisverzorgerDienst => thuisverzorgerDienst.getZoneIds());
    return [...new Set(allZoneIds)]
  }

  isVerwijderd(): boolean {
    return this.verwijderd;
  }

  toDto(): ThuisverzorgerDto {
    return {
      id: this.id,
      voornaam: this.voornaam,
      achternaam: this.achternaam,
      personeelsnummer: this.personeelsnummer,
      email: this.email,
      diensten: this.diensten.map(dienst => dienst.toDto()),
    };
  }
}

export interface ThuisverzorgerDto {
  id: string;
  voornaam: string;
  achternaam: string;
  personeelsnummer: string;
  email: string;
  diensten: Array<ThuisverzorgerDienstDto>;
}
